



























import { Vue, Component, Watch } from "vue-property-decorator";
import Loading from "vue-loading-overlay";
import QNav from "./qNav.vue";
import QSidebar from "./qSidebar.vue";
import QSidebarAadminCustomer from "./qSidebarAdminCustomer.vue";
import QFooter from "./qFooter.vue";
import store from "@/store";

import "vue-loading-overlay/dist/vue-loading.css";
import "flatpickr/dist/flatpickr.css";
import { namespace } from "vuex-class";
import { DATE_TIMESTAMP_FORMAT, ROLE_ADMIN } from "@/common/constant";
import User from "@/model/user";
import orderApi from "@/api/orderApi";
import moment from "moment";
import ChangeUserInfo from "@/views/pages/changeUserInfo.vue";
import CustomerUser from "@/model/customerUser";
import userApi from "@/api/userApi";

const authStore = namespace("Auth");

Vue.use(Loading);
@Component({
  name: "AdminLayout",
  components: {
    QFooter,
    QNav,
    QSidebar,
    QSidebarAadminCustomer,
    QScripts: () => import("@/common/qScripts.vue"),
    ChangeUserInfo,
  },
})
export default class AdminLayout extends Vue {
  public classPage: string[];
  public classToggle = [];
  // @Watch("$route", { immediate: true, deep: true })
  // onUrlChange(newValue: any, oldValue: any) {
  //   if (newValue && oldValue && newValue.name !== oldValue.name) {
  //     this.setImportTitle();
  //     this.changedRoute++;
  //   }
  // }
  @authStore.Getter
  public getUserType!: string;

  @authStore.Getter
  getUserLogging!: User;

  @authStore.Getter
  public isCustomer!: boolean;

  @authStore.Getter
  getCustomerUser!: CustomerUser;

  @authStore.Getter
  public isLoginTime!: boolean;

  @authStore.Action
  updateIsLoginTime!: (isLoginTime: boolean) => void;

  @authStore.Action
  fetchCurrentUser!: (user) => void;

  @authStore.Action
  updateUserType!: (userType: string) => void;

  public changedRoute = 1;

  get titlePage(): string {
    return this.$route.meta.title || "";
  }
  get subTitle(): string {
    return this.$route.meta.subTitle || "";
  }

  dynamicSubTitle = "";

  userName = "";

  @Watch("$route.currentRoute", { deep: true, immediate: true })
  changeCurrentRoute() {
    this.getClassPage();
    this.setImportTitle();
  }

  public async mounted() {
    await this.getCurrentUser();
    
    if (this.isCustomer && this.getCustomerUser.is_changed_password == false) {
      this.updateIsLoginTime(false);

      // show change user info form when password is not changed
      this.showUserInfo();
    }
  }

  public async getCurrentUser() {
    const result = await userApi.me();
    this.updateUserType(result.user_type);
    // this.updateIsLoginTime(true);
    await this.fetchCurrentUser(result.user_info);
  }

  public showUserInfo() {
    (this.$refs.changeUserInfo as ChangeUserInfo).show();
  }

  public setImportTitle() {
    if (this.$route.meta.isShowLastOrderTimeTitle) {
      orderApi.getOrderHistoryLastUpdateTime().then((response) => {
        this.dynamicSubTitle =
          "（最終更新日時：" +
            ( response ? moment(response).format(DATE_TIMESTAMP_FORMAT) : '' ) +
          "）";
      });
    } else {
      this.dynamicSubTitle = "";
    }

    // if (this.$route.meta.isShowImportTitle) {
    //   UserApi.getImportHistory().then((response) => {
    //     this.importTitle = response.data.data
    //       ? response.data.data.sync_datetime
    //       : "";
    //     if (this.importTitle) {
    //       this.importTitle = "（最終インポート日時：" + this.importTitle + "）";
    //     }
    //   });
    // } else {
    //   this.importTitle = "";
    // }
  }
  get isLoading(): boolean {
    console.log(store);
    return true;
  }

  getClassPage() {
    this.changedRoute; // hack to re-computed
    const initalClass = ["mb__admin mb__base-color-blue"];
    if (this.$router.currentRoute.meta.className) {
      initalClass.push(this.$router.currentRoute.meta.className);
    }
    console.log(initalClass);
    this.classPage = initalClass;
  }

  get currentSiderbarComponent(): string {
    if (this.getUserType && this.getUserType === ROLE_ADMIN) {
      return "QSidebar";
    }
    return "QSidebarAadminCustomer";
  }

  public reload() {
    const userPageName = ['admin.admin', 'admin-customer.customers'];
    if (userPageName.includes(this.$route.name)) {
      location.reload();
    }
  }

  public closeMenu(event) {
    if (event.target && event.target._prevClass == "mb__admin-navarea" ) {
      const bodyNode = document.querySelector("body");
      const menuBarNode = document.querySelector("#menu_bar");
      bodyNode.classList.remove('open')
      menuBarNode.classList.remove('open')
    }
  }
}
